module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-9"
    }
  }, [_vm._v("Chapter 7")]), _vm._v(" "), _c('div', {
    staticClass: "hr"
  }, [_c('p', {
    staticClass: "CT"
  }, [_vm._v("Johanna")]), _vm._v(" "), _c('p', {
    staticClass: "CIT"
  }, [_vm._v("“I swear on my honor, and Dom’s and your own, Mother. I did not know he was a girl.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That doesn’t matter,” a woman’s voice responded. “You know the law. We don’t hand out justice with our fists.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Look at the way he’s dressed. It’s completely inappropriate. And he was poach—”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Referring to the girl as a ‘he’ won’t change the facts, Rafael.” The tone was a velvet-wrapped dagger. Johanna kept her eyes closed, hoping to avoid the woman who could wield it so potently. ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Her location was foreign, the sounds of horses and scent of lilacs on the air proved that certainty. And good glory, the satin coverlet felt delicious against her palms. ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You beat someone into unconsciousness. You bloodied her leg and likely broke her ribs.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I wouldn’t have hurt her if I’d known—”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“So you’d annihilate a boy you outweigh by double?” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“He tried to strangle me.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("She")]), _vm._v(" defended herself. ” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The silence was damning, neither of them spoke, but the room filled with tension. ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Rafi.” The woman’s voice gentled. “What would you have me do? Shall I pretend it never happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Fabric rustled, and Johanna opened her eyes a narrow slit. A woman and a man stood silhouetted against a large stained glass window. They were both tall and fine featured, but the man—"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("boy, ")]), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("really")]), _vm._v("—had dark hair that curled on the verge of wild. ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I would never ask you to ignore the law, Your Grace,” he said with unusual formality. “I let my temper get the best of me. I’ll take the punishment you deem worthy.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("“Your Grace”? Where am I?")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The woman raised her hand to her son’s cheek. “We won’t make it public knowledge. A few witnesses, perhaps the new weaponsmaster and the Captain of the Guard. Just enough people to satisfy questions, if there are any.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“And the girl, of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It is her right.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Another hesitation, a heavy exhale. “Will she still be tried for poaching?” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Johanna, a consummate actress, could have feigned sleep for days to come, especially in a bed more comfortable than any she’d ever enjoyed. But she also knew the importance of dramatic timing. She’d been coached for years on perfect delivery, and this was her moment to make an entrance into the conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She tried to push herself upright, but her head spun like a loose wagon wheel. The groan of pain was legitimate. ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Our fair thief wakes,” the boy mumbled, stepping away from the window and nearer her bed. She saw then what the window’s light had disguised: dark eyes framed with thick lashes and straight brows, a fine nose, and a strong chin. He was perhaps two years her senior, nearing naming age. ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The face wasn’t unfamiliar. It had been a few years since her troupe had performed for Duke and Lady DeSilva’s estate, but she remembered their son as a smiling boy who applauded and cheered and begged for so many songs that her mother’s infallible voice grew weary. ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I am many things, sir, but poacher is not a title I bear.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He coughed, a cold approximation of a laugh and likely the best this stern—"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("but unfortunately handsome")]), _vm._v("—young man could manage. “The stag hanging in the smokehouse begs to differ.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Johanna hated the way he loomed over her. She’d already spent too much time at his mercy and struggled to rise. ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Let me help, dear.” The woman, an older version of the Lady DeSilva Johanna remembered, sat beside her on the bed and placed a supporting hand behind her shoulder. ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Johanna nodded her thanks to the duchess. “I shot the stag in the public forest, not far from Farmer Milner’s mango orchard.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Liar,” Rafi snapped. “You were well beyond the stream when I stumbled upon you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Sow-kissing mud sucker.")]), _vm._v(" Johanna’s eyes traced his perfectly tailored hunting gear, high-quality leather jerkin and breeches. “Send one of your retainers to follow the blood trail, my lord. I’m certain you employ "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("someone")]), _vm._v(" who could track it to where I made my shot.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You took it on my land.” Fire burned in his dark eyes and blazed red spots on his cheeks. ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Should I have let it suffer?” Johanna raised a hand, grimacing at the bolt of pain in her side. “Never mind. It’s apparent you enjoy punishing the helpless.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Why you venomous—”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Rafi.” The lady called her son to heel. “Go. Send Snout to find the trail and follow it to its origin.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The anger Johanna felt at being termed a poacher sputtered. What if the grass had been trampled? What if the blood had washed away? Johanna licked her lips nervously, her tongue finding a tender split. ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Your Grace.” She turned her gray eyes on the lady, offering a look that managed to be both humble and innocent. “I swear on my honor, on my family’s, on my dear father’s grave, that the deer was in the public forest when I took the shot. Please believe me.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Rafael gave another irritated cough-laugh. “How long were you awake and listening to our conversation?” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Long enough to make sure I hadn’t been tossed into the bed of a scoundrel.” She touched her forehead where a fresh bruise hummed. It must have been the last shot of their brawl because she didn’t remember receiving it. ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’d never touch an ill-bred—”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Enough!” The lady’s voice cut through the argument. “I gave you a command, my son, and I expect you to follow it with haste. We wouldn’t want a sudden storm to obliterate her claims.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes, Mother.” He gave her a half bow and glared vitriol at Johanna. “I’ll be back in less than two hours with confirmation of one of our stories.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-043c7fc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch007.vue
// module id = 84
// module chunks = 0